import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { InterfaceScroller, InterfaceStyles } from "../Components/Interface";
import { SiteSyles, useIsVisible, useSite } from "../Context/SiteContext";
import { DrawOnText } from "../Landing/Landing";
import { useEffect, useRef, useState } from "react";
import { faExpand, faTimes } from "@fortawesome/free-solid-svg-icons";

export const ProvenceSection = () => {

    return(
            <div style={{
                display:'flex',
                ...SiteSyles.column,
            }}>
               <ProvenceVideo></ProvenceVideo>
            </div>
        );

};

const ProvenceVideo = () => {

    const Site = useSite();

    const videoRef = useRef<HTMLVideoElement>(null);
    const videoVisible = useIsVisible(videoRef);

    useEffect(()=>{
        videoVisible ? videoRef.current?.play() : videoRef.current?.pause();
    },[videoVisible]);

    const [expandVideo, setExpandVideo] = useState(false);
    const [startLineTwo, setStartLineTwo] = useState(false);

    useEffect(()=>{
        Site.provenceElementRef!.current = videoRef?.current;
    },[]);

    return(
        <div 
            style={{
                ...SiteSyles.column,
                position:'relative',
                width:'100vw',
                minHeight:'33vh',
                maxHeight: !expandVideo ? '33vh' : '150vh',
                transition:'max-height 2s ease',
                overflow:'hidden',
                cursor: !expandVideo ? 'pointer' : undefined,
            }} 
            onClick={()=>{
                if(!expandVideo){
                    setExpandVideo(true);
                }
            }}
        >
            <div style={{
                display:'flex',
                flex:1,
            }}>
                <video 
                    ref={videoRef} 
                    playsInline 
                    muted
                    loop 
                    style={{
                        position:'absolute',
                        height:'100%',
                        width:'100%',
                        objectFit: 'cover',
                        opacity: expandVideo ? 0.4 : 1,
                        transition: 'opacity 1s ease',
                        filter: expandVideo ? 'blur(5px)' : undefined,
                    }} 
                >
                    <source src="assets/provence/provence-banner-1.mp4"></source>
                </video>
                <div style={{
                    display:'flex',
                    flexDirection:'column',
                    gap:10,
                    position:'relative',
                    flex:1,
                    overflow:'hidden',
                    padding:30,
                    paddingTop:135,
                    zIndex:1,
                    maxHeight:'100vh',
                    opacity: expandVideo ? 1 : 0,
                    transition: 'opacity 1s ease',
                }}>
                    <div style={{
                        ...SiteSyles.text, 
                        color:SiteSyles.siteYellow,
                        textShadow: '0px 0px 5px #000',
                    }}>{provenceParagraphOne}</div>
                    <div style={{
                        ...SiteSyles.text, 
                        color:SiteSyles.siteYellow,
                        textShadow: '0px 0px 5px #000',
                    }}>{provenceParagraphTwo}</div>
                    <div style={{
                        ...SiteSyles.text, 
                        color:SiteSyles.siteYellow,
                        textShadow: '0px 0px 5px #000',
                    }}>{provenceParagraphThree}</div>
                    <div style={{
                        ...SiteSyles.text, 
                        color:SiteSyles.siteYellow,
                        textShadow: '0px 0px 5px #000',
                    }}>{provenceParagraphFour}</div>
                    <a href="https://www.provencemediaserver.com" target="_blank" style={{
                        ...SiteSyles.text, 
                        color:SiteSyles.siteYellow,
                        textShadow: '0px 0px 5px #000',
                        alignSelf:'center',
                        cursor:'pointer',
                        marginTop:30,
                        marginBottom:20
                    }}>{"www.provencemediaserver.com"}</a>
                </div>
                <div style={{
                    position:'absolute',
                    right:0,
                    bottom:0,
                    width:40,
                    height:40,
                    ...InterfaceStyles.center,
                    pointerEvents: expandVideo ? undefined: 'none',
                    cursor:'pointer',
                    zIndex:2,
                }} onClick={()=>{
                    setExpandVideo(false);
                }}>
                    <FontAwesomeIcon icon={expandVideo ? faTimes : faExpand} style={{color:'white',textShadow:'0px 0px 2px #000'}}></FontAwesomeIcon>
                </div>
                <div style={{
                    display:'flex',
                    position:'absolute',
                    right: 20,
                    top: 20,
                    flexDirection:'column',
                    justifyContent:'center',
                    alignItems:'flex-end',
                    mixBlendMode:'plus-lighter',
                    filter:'blur(1px)',
                }}>
                    <div style={{...SiteSyles.row, ...SiteSyles.centerEnd, gap: 10,}}>
                        <img src="assets/provence-logo.png" style={{
                            bottom:0,
                            height:28,
                            objectFit:'contain',
                        }}></img>
                        <DrawOnText text="Provence" start={videoVisible} onComplete={()=>{
                            setTimeout(()=>setStartLineTwo(true),300);
                        }}></DrawOnText>
                    </div>
                    <DrawOnText text="Interactive Media Server" start={startLineTwo} style={{
                        fontSize:24,
                    }}></DrawOnText>
                </div>
            </div>
        </div>
    );

};

const provenceParagraphOne = `Provence is a media server like none other. Set apart by its focus on networked access and interactivity that opens doors to new possibilities in Media Playback, live entertainment and immersive spaces. Blurring the lines between these worlds to create something new.`;

const provenceParagraphTwo = `Paired with its client applications for all major interfaces (Windows, MacOS, iOS and Android) Provence allows for interactive/multimedia playback, file management and control from any device to any device on your network.`;

const provenceParagraphThree = `The interactive nature allows not only operator but actors to invoke playback cues to all devices from interactions as simple as a touch  to fully animated multi-phase multi-device data driven sequences.`;

const provenceParagraphFour = 'Seen in action on Star Trek: Startfleet Acacademy & Strange New Worlds; The Terminal List; Cross; and many more.';